module.exports = __webpack_public_path__ + "static/media/religion.4d79c4d0.jpg";